import * as mutations from './mutations'
import Server from '@/service/server'
import { stat } from 'fs'
import persianDate from 'persian-date/dist/persian-date.js'

export default {
  namespaced: true,
  state: {
    chargePrice: '',
    subscriptionPlan: {},
    payment: {},
    accounting: {},
    subscription: {},
    subscriptionPlans: [],
    routeName: '',
    userBasketCode: '',
    factor: {},
    orderCode: '',
    currentBalance: '',
    paymentHistory: {},
    paymentTransaction: {}
  },
  getters: {
    chargePrice (state: any) {
      return state.chargePrice
    },
    subscriptionPlan (state: any) {
      return state.subscriptionPlan
    },
    payment (state: any) {
      return state.payment
    },
    accounting (state: any) {
      return state.accounting
    },
    subscription (state: any) {
      return state.subscription
    },
    subscriptionPlans (state: any) {
      return state.subscriptionPlans
    },
    routeName (state: any) {
      return state.routeName
    },
    userBasket (state: any) {
      return state.userBasketCode
    },
    userFactor (state: any) {
      return state.factor
    },
    userOrderCode (state: any) {
      return state.orderCode
    },
    userBalance (state: any) {
      return state.currentBalance
    },
    userPaymentHistory (state: any) {
      return state.paymentHistory
    },
    userPaymentTransaction (state: any) {
      return state.paymentTransaction
    }

  },
  actions: {
    setChargePrice (context: any, chargePrice: string) {
      context.commit('setChargePrice', chargePrice)
    },
    setSubscriptionPlan (context: any, subscriptionPlan: object) {
      context.commit('setSubscriptionPlan', subscriptionPlan)
    },
    setPayment (context: any, payment: object) {
      context.commit('setPayment', payment)
    },
    setAccounting (context: any, accounting: object) {
      context.commit('setAccounting', accounting)
    },
    setSubscription (context: any, subscription: object) {
      context.commit('setSubscription', subscription)
    },
    setSubscriptionPlans (context: any) {
      const promise = Server.getSubscriptionPlans().then((response: any) => {
        var plans = context.rootGetters['tenantDesign/config'].plans
        var subscriptionPlansData = new Array()
        response.body.result.map((value: any) => {
          plans.find((plan: any) => {
            if (plan.code === value.code) {
              var object = {
                Icon: plan.icon,
                Title: value.name,
                Price: (value.amount) / 10,
                Description: plan.description,
                Discount: '',
                SubscriptionTime: plan.subscriptionTime,
                Accent: plan.accent,
                TextAccent: plan.textAccent,
                Unit: 'تومان',
                DiscountedPrice: '',
                Type: value.type,
                PlanCode: plan.code
              }
              subscriptionPlansData.push(object)
            }
          })
        })
        context.commit('setSubscriptionPlans', subscriptionPlansData)
        return subscriptionPlansData.reverse()
      })
      return promise
    },
    setCurrentBalance (context: any) {
      const promise = Server.getBalance().then((response: any) => {
        if (response.body.success === true) {
          context.commit('setUserBalance', (response.body.result.balance) / 10)
          return response
        }
      })
      return promise
    },
    setRouteName (context: any, routeName: Object) {
      context.commit('setRouteName', routeName)
    },
    loadPaymentHistory (context: any) {
      const promise = Server.paymentHistory().then((response: any) => {
        if (response.body.success === true) {
          var result = response.body.result
          var historyItems = new Array()
          for (var i = 0; i < result.items.length; i++) {
            var historyItem = {
              Type: 'Successful',
              Date: new persianDate(new Date(result.items[i].creationTime)).format('L'),
              Time: new persianDate(new Date(result.items[i].creationTime)).format('hh:mm a'),
              Title: result.items[i].description,
              BankingFollowCode: result.items[i].requesterRefId,
              Amount: result.items[i].increasedAmount,
              PriceUnit: result.items[i].currencyCode
            }
            historyItems.push(historyItem)
          }
          context.commit('setUserPaymentHistory', historyItems)
          return historyItems
        }
      })
      return promise
    },
    addToBasket (context: any, payload: any) {
      let params = {
        basketCode: payload.basketCode,
        planCode: payload.planCode
      }

      const promise = Server.addToBasket(params, params).then((response: any) => {
        var result = response.body.result
        if (response.body.success === true) {
          context.commit('setUserBasket', result.basketCode)
          return result
        }
      },
      (error: any) => {

      }
      )
      return promise
    },
    applyDiscountCode (context: any, payload: any) {
      let params = {
        basketCode: payload.basketCode,
        planCode: payload.planCode,
        code: payload.code
      }

      const promise = Server.applyDiscountCode(params, params).then((response: any) => {
        var result = response.body.result
        context.commit('setUserFactor', result)
        return result
      }, (errorResponse: any) => {
        let error = errorResponse.body.error
      })
      return promise
    },
    checkout (context: any, payload: any) {
      let params = {
        basketCode: payload.basketCode
      }
      const promise = Server.checkOut(params, params).then((response: any) => {
        var result = response.body.result
        context.commit('setOrderCode', result.orderCode)
        return context.dispatch('pay', payload)
      })
      return promise
    },
    pay (context: any, payload: any) {
      var orderCode = context.state.orderCode
      var useCurrentBalance = payload.useCurrentBalance
      let location = window.location
      let params = {}
      if (!useCurrentBalance) {
        params = {
          OrderCode: orderCode,
          TransactionRequestMode: 'ChargeAndPay',
          TransactionRequestMethod: 'BankGateway',
          RequesterSubProductType: '',
          RequesterProductType: 'Game',
          TransactionType: 'IncreaseChargeByPaymentGateway',
          RequesterService: 'Bazili',
          Description: 'PlzGoToBank',
          PaymentProvider: 'zarinpal',
          CallbackUrl: location.origin + '/paymentCallback'
        }
      }
      if (useCurrentBalance) {
        params = {
          OrderCode: orderCode,
          TransactionRequestMode: 'Pay',
          TransactionRequestMethod: 'UserAccount',
          RequesterSubProductType: '',
          RequesterProductType: 'Game',
          TransactionType: 'DecreaseChargeByWithdraw',
          RequesterService: 'Bazili',
          Description: 'PlzGoToBank',
          PaymentProvider: 'zarinpal',
          CallbackUrl: location.origin + '/paymentCallback'
        }
      }
      const promise = Server.pay(params).then((response: any) => {
        return response
      })
      return promise
    },
    charge (context: any, payload: any) {
      let location = window.location
      let params = {
        amount: (payload.value) * 10,
        currency: 'IRR',
        paymentProvider: 'zarinpal',
        requesterService: 'Bazili',
        description: 'PlzGoToBank',
        callbackUrl: location.origin + '/paymentCallback'
      }
      const promise = Server.charge(params).then((response: any) => {
        return response
      })
      return promise
    },
    getPaymentTransaction (context: any, payload: any) {
      let params = {
        transactionId: payload.transactionId
      }
      const promise = Server.getTransaction(params).then((response: any) => {
        if (response.body.success === true) {
          context.commit('setUserPaymentTransaction', response.body.result)
          return response.body.result
        }
      })
      return promise
    }
  },
  mutations: {
    setChargePrice (state: any, chargePrice: string) {
      state.chargePrice = chargePrice
    },
    setSubscriptionPlan (state: any, subscriptionPlan: string) {
      state.subscriptionPlan = subscriptionPlan
    },
    setPayment (state: any, payment: string) {
      state.payment = payment
    },
    setAccounting (state: any, accounting: string) {
      state.accounting = accounting
    },
    setSubscription (state: any, subscription: string) {
      state.subscription = subscription
    },
    setSubscriptionPlans (state: any, subscriptionPlans: any[]) {
      state.subscriptionPlans = subscriptionPlans
    },
    setRouteName (state: any, routeName: String) {
      state.routeName = routeName
    },
    setUserBasket (state: any, basketCode: string) {
      state.userBasketCode = basketCode
    },
    setUserFactor (state: any, factor: any) {
      state.factor = factor
    },
    setOrderCode (state: any, orderCode: any) {
      state.orderCode = orderCode
    },
    setUserBalance (state: any, balance: any) {
      state.currentBalance = balance
    },
    setUserPaymentHistory (state: any, paymentHistory: any) {
      state.paymentHistory = paymentHistory
    },
    setUserPaymentTransaction (state: any, transaction: any) {
      state.paymentTransaction = transaction
    }

  }
}
